module.exports = __webpack_public_path__ + "img/2019PropaneDelivery_1.5da9761f.png";